exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-toast,.igx-toast--bottom,.igx-toast--middle,.igx-toast--top{display:block;margin:2.625em auto;position:fixed;text-align:center;left:50%;transform:translate3d(-50%,0,0);min-width:52px;padding:1em 1.5em;background-color:rgba(0,0,0,.54);border-radius:26px;color:#fff;font-size:.875em;line-height:1.5em;opacity:0;z-index:999999}.igx-toast--top{top:0}.igx-toast--middle{top:50%;transform:translate3d(-50%,-50%,0)}.igx-toast--bottom{bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/toast/toast.component.scss
// module id = 133
// module chunks = 0 1